import React, { useEffect, useState } from 'react';
import { Button, Modal, Form, Input, DatePicker } from 'antd';
import CustomerPicker from "components/pickers/customer"
import InputNumber from "components/input-number"
import ImagePicker from "components/pickers/image/MultiImagePicker"
import DebtService from "services/debt"
import { useApp } from 'contexts/app';
import dayjs from 'dayjs';
import ComonFields from "./ComonFields"
const service = new DebtService();
const UpdateDebt = ({ onSaved, id, open = false, onClose }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const { showNotify } = useApp();
    const showModal = () => {
        form.setFieldsValue({ date: dayjs() })
        setIsModalOpen(true);
    };
    useEffect(() => {
        if (open != isModalOpen) {
            setIsModalOpen(open)
        }
    }, [open])

    useEffect(() => {
        if (isModalOpen && id) {
            loadData();
        }
    }, [isModalOpen, id])

    const loadData = async () => {
        form.setFieldsValue({ date: dayjs() })
        var item = await service.getByID(id);

        if (item) {
            form.setFieldsValue({ ...item, date: dayjs(item.date) })
            setIsModalOpen(true);
        } else {
            form.setFieldsValue({ date: dayjs() })

        }
    }


    useEffect(() => {
        if (!isModalOpen) {
            if (onClose)
                onClose()
        }
    }, [isModalOpen])
    const handleOk = () => {

        form.submit();
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const onFinish = async (values) => {
        await service.update(values);
        showNotify("Đã cập nhật");
        if (onSaved) {
            onSaved();
        }
        setIsModalOpen(false)

    }
    return (
        <>

            <Modal
                title="Cập nhật"
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
            >


                <Form
                    layout={"vertical"}
                    form={form}
                    onFinish={onFinish}
                >

                    <Form.Item name="id" hidden>

                    </Form.Item>
                    <ComonFields></ComonFields>
                </Form>

            </Modal>
        </>
    );
};
export default UpdateDebt;